export default {
  "pages.groups.members.selectUsers": "Search and pick users to add (multiple)",
  "pages.groups.members.addBatchSuccess": "Added {count} members",
  "pages.groups.members.addBatchFailed": "Failed to add {count} members",
  "pages.groups.members.addActionCount": "Add {count} people",
  "pages.platforms.form.loginUrl.pattern": "SSO platforms must use http/https. For app deep links, enable \"External platform\" first.",
  "pages.platforms.form.loginUrl.banned": "This scheme is not allowed",
  "pages.platforms.form.loginUrl.invalid": "Enter a full URL with a scheme",
  "pages.me.switchAccount": "Switch account",
  "pages.me.accountCount": "{count} accounts",
  "pages.platforms.form.isExternal.label": "External platform",
  "pages.platforms.form.isExternal.tooltip": "Systems like ADP or an external ERP that do not use single sign-on. Shown on the dashboard as a link only; users sign in on the other site, and it cannot act as an OAuth client.",
  "pages.launcher.external.title": "Open \"{name}\"",
  "pages.launcher.external.content": "This system does not support automatic sign-in. You will need its own username and password after it opens.",
  "pages.launcher.external.ok": "Open anyway",
  "pages.me.otherAccounts": "Other accounts",
  "pages.me.preferences": "Preferences",
  "pages.myPlatforms.greeting.night": "Up late",
  "pages.myPlatforms.greeting.morning": "Good morning",
  "pages.myPlatforms.greeting.afternoon": "Good afternoon",
  "pages.myPlatforms.greeting.evening": "Good evening",
  "pages.myPlatforms.count": "{count} systems available",
  "pages.user.login.choose.signedOut": "Signed out",
  "pages.user.login.sessionExpired": "This account has been signed out. Please sign in again.",
  "pages.platforms.form.logoUrl.label": "Platform icon",
  "pages.platforms.form.logoUrl.tooltip": "Optional. Shown on the user dashboard. Leave empty to generate an icon from the platform initial and accent color.",
  "pages.platforms.form.logoUrl.pattern": "Enter a full http/https URL",
  "pages.platforms.form.loginUrl.tooltip": "Optional. Only platforms with a login URL appear on the user dashboard. Leave it empty for apps and handheld devices that have no web entry point.",
  "pages.register.title": "Create an account",
  "pages.register.subtitle": "Sign up for Korsmet single sign-on",
  "pages.register.haveAccount.prefix": "Already have an account? ",
  "pages.register.haveAccount.action": "Sign in",
  "pages.platforms.form.brandColor.label": "App icon background",
  "pages.platforms.form.brandColor.tooltip": "Used only for app icon backgrounds in the app list. Leave empty to use the default blue. Sign-in and consent pages use the Auth default colors.",
  "pages.platforms.form.brandColor.pattern": "Use a #RRGGBB color value",
  "pages.oauth.authorize.progress.title": "Signing in to \"{platform}\"",
  "pages.oauth.authorize.progress.subtitle": "Requesting authorization, please wait",
  "pages.oauth.authorize.progress.hint": "You will return to the platform automatically",
  "pages.user.login.choose.title": "Choose an account",
  "pages.user.login.choose.subtitle": "to continue with Korsmet single sign-on",
  "pages.user.login.choose.forPlatform": "to continue to \"{platform}\"",
  "pages.user.login.choose.another": "Use another account",
  "pages.user.login.choose.privacy": "Not your device? Sign in with a private window so the account is not kept on this computer.",
  "pages.user.login.identify.title": "Sign in",
  "pages.user.login.identify.subtitle": "with your Korsmet account",
  "pages.user.login.next": "Next",
  "pages.user.login.backToChoose": "Back to account list",
  "pages.user.login.password.title": "Enter your password",
  "pages.user.login.password.subtitle": "Welcome back",
  "pages.user.login.password.swap": "Change",
  "pages.user.login.submitAndContinue": "Sign in and continue",
  "pages.user.login.failure": "Incorrect account or password. Please try again.",
  "pages.user.login.register.prefix": "Do not have an account? ",
  "pages.user.login.register.action": "Register",
  "pages.oauth.authorize.choose.title": "Choose an account",
  "pages.oauth.authorize.choose.subtitle": "to continue to \"{platform}\"",
  "pages.oauth.authorize.choose.another": "Use another account",
  "pages.oauth.authorize.confirm.toPlatform": "Sign in to \"{platform}\"",
  "pages.oauth.authorize.confirm.withAccount": "with your Korsmet account",
  "pages.oauth.authorize.confirm.notYou": "Not you?",
  "pages.oauth.authorize.confirm.scopeProfile": "\"{platform}\" will get your name and email",
  "pages.oauth.authorize.confirm.scopeId": "and your account identifier on that platform",
  "pages.oauth.authorize.confirm.fine": "Korsmet Auth only confirms who you are. Your password is never shared with the platform.",
  "pages.oauth.authorize.actions.cancel": "Cancel",
  "pages.oauth.authorize.actions.continue": "Continue",
  'pages.user.login.platformFallback': 'Target Platform',
  "pages.user.login.oauth.intro": "You will return to \"{platform}\" after signing in",
  'pages.user.login.oauth.validating': 'Validating credentials…',
  'pages.user.login.oauth.success': 'Sign-in succeeded. Redirecting to the "{platform}" authorization page…',
  'pages.user.login.oauth.failure': 'Sign-in failed. Check your credentials or try again later.',
  'pages.user.login.subtitle': 'Unified authentication and access control platform',
  'pages.user.login.submit': 'Sign In',
  'pages.user.login.register': "Don't have an account? Register",
  'pages.user.login.placeholder.identifier': 'Enter username or email',
  'pages.user.login.validation.identifier': 'Please enter a username or email',
  'pages.user.login.placeholder.password': 'Enter password',
  'pages.user.login.validation.password': 'Please enter your password',
  'pages.user.login.autoLogin': 'Auto login',
  'pages.register.submit': 'Register',
  'pages.register.success': 'Registration complete. An administrator needs to activate your account before you can sign in.',
  'pages.register.failure': 'Registration failed. Please try again later.',
  'pages.register.haveAccount': 'Already have an account? Sign in',
  'pages.register.notice.title': 'Before you register',
  "pages.register.notice.description": "New accounts start disabled. An administrator has to approve yours before you can sign in.",
  'pages.register.username.placeholder': 'Username (3-20 characters)',
  'pages.register.username.required': 'Please enter a username',
  'pages.register.username.min': 'Username must be at least 3 characters',
  'pages.register.username.max': 'Username must be at most 20 characters',
  'pages.register.username.pattern': 'Username may only contain letters, numbers and underscores',
  'pages.register.fullName.placeholder': 'Full name',
  'pages.register.fullName.required': 'Please enter your full name',
  'pages.register.fullName.min': 'Full name must be at least 2 characters',
  'pages.register.email.placeholder': 'Email (optional)',
  'pages.register.email.invalid': 'Please enter a valid email address',
  'pages.register.password.placeholder': 'Password (at least 8 characters)',
  'pages.register.password.required': 'Please enter a password',
  'pages.register.password.min': 'Password must be at least 8 characters',
  'pages.register.confirmPassword.placeholder': 'Confirm password',
  'pages.register.confirmPassword.required': 'Please confirm your password',
  'pages.register.confirmPassword.mismatch': 'The two passwords do not match',
  'pages.oauth.authorize.brandTitle': 'Korsmet Auth',
  'pages.oauth.authorize.processing': 'Processing your authorization request',
  'pages.oauth.authorize.confirm.chooseTitle': 'Choose an account',
  'pages.oauth.authorize.confirm.chooseDescription': 'Pick an account to continue to this platform',
  'pages.oauth.authorize.confirm.currentTag': 'Current',
  'pages.oauth.authorize.actions.useAnotherAccount': 'Use another account',
  'pages.oauth.authorize.confirm.title': 'Confirm Account',
  'pages.oauth.authorize.confirm.description': 'Continue signing in to the third-party platform with this account?',
  'pages.oauth.authorize.confirm.platform': 'Target platform: {platform}',
  'pages.oauth.authorize.confirm.nameLabel': 'Current account name',
  'pages.oauth.authorize.confirm.emailLabel': 'Current account email',
  'pages.oauth.authorize.confirm.email': 'Current account email: {email}',
  'pages.oauth.authorize.actions.continueAccount': 'Continue with this account',
  'pages.oauth.authorize.actions.switchAccount': 'Use another account',
  'pages.oauth.authorize.actions.backLogin': 'Back to login',
  'pages.oauth.authorize.actions.retry': 'Retry',
  'pages.oauth.authorize.steps.check.title': 'Check Session',
  'pages.oauth.authorize.steps.check.description': 'Verify user identity',
  'pages.oauth.authorize.steps.confirm.title': 'Confirm Account',
  'pages.oauth.authorize.steps.confirm.description': 'Confirm the sign-in account',
  'pages.oauth.authorize.steps.authorize.title': 'Issue Code',
  'pages.oauth.authorize.steps.authorize.description': 'Return to platform',
  'pages.oauth.authorize.status.redirectLogin': 'Not signed in. Redirecting to login...',
  'pages.oauth.authorize.status.redirectLoginExpired': 'Your session expired. Redirecting to login...',
  'pages.oauth.authorize.status.authorizing': 'Requesting authorization...',
  'pages.oauth.authorize.status.success': 'Authorized. Redirecting to the platform...',
  'pages.oauth.authorize.error.invalidResponseType': 'Invalid response_type. It must be "code".',
  'pages.oauth.authorize.error.missingClientId': 'Missing client_id parameter.',
  'pages.oauth.authorize.error.missingRedirectUri': 'Missing redirect_uri parameter.',
  'pages.oauth.authorize.error.http': 'Authorization failed (HTTP {status})',
  'pages.oauth.authorize.error.missingRedirectUrl': 'The backend did not return a redirect URL.',
  'pages.oauth.authorize.error.unknownResponse': 'Unknown response type.',
  'pages.oauth.authorize.error.failed': 'Authorization failed',
  'pages.oauth.authorize.error.title.params': 'Invalid Parameters',
  'pages.oauth.authorize.error.title.authorize': 'Authorization Failed',
  'pages.oauth.authorize.params.title': 'Details',
  'pages.oauth.authorize.params.errorCode': 'Error code:',
  'pages.oauth.authorize.params.rawMessage': 'Raw message:',
  'pages.oauth.authorize.error.noRedirectUri': 'This platform has no registered redirect URI. Ask an administrator to add one under Platforms.',
  'pages.oauth.authorize.error.redirectUriNotAllowed': 'The redirect URI is not on this platform’s allow list. Ask an administrator to check it (case and trailing slash must match exactly).',
  'pages.oauth.authorize.error.noPlatformAccess': 'This account is not authorized for the platform. Ask an administrator to grant access.',
  'pages.oauth.authorize.error.platformNotFound': 'Platform not found or disabled. Check the client_id.',
  'pages.oauth.authorize.error.platformUnavailable': 'This platform is disabled.',
  'pages.oauth.authorize.error.accountUnavailable': 'This account is disabled. Please contact an administrator.',
  'pages.oauth.authorize.params.platform': 'Platform:',
  'pages.oauth.authorize.params.redirectUri': 'Redirect URI:',
  'pages.oauth.authorize.params.scope': 'Scope:',
  'pages.oauth.authorize.info.title': 'Authorization Info',
  'pages.404.subTitle': 'Sorry, the page you visited does not exist.',
  'pages.404.buttonText': 'Back Home',
  'pages.common.status.enabled': 'Enabled',
  'pages.common.status.disabled': 'Disabled',
  'pages.common.cancel': 'Cancel',
  'pages.common.confirm': 'Confirm',
  'pages.common.roles.admin': 'Administrator',
  'pages.common.roles.user': 'Standard User',
  'pages.common.unknownPlatform': 'Unknown Platform',
  'pages.common.notProvided': 'Not provided',
  'pages.common.notAvailable': '—',
  'pages.common.systemCreated': 'System Created',
  'pages.common.platformMissing': 'Linked platform missing (ID: {id})',
  'pages.common.neverLoggedIn': 'Never logged in',
  'pages.common.loading': 'Loading…',
  'pages.users.title': 'User Management',
  'pages.users.loadError': 'Failed to load users, please try again later.',
  'pages.platforms.loadError': 'Failed to load platforms.',
  'pages.users.assignmentsLoadError': 'Failed to load assignments, please try again later.',
  'pages.users.actions.create': 'Add User',
  'pages.users.actions.edit': 'Edit',
  'pages.users.actions.assign': 'Grant Access',
  'pages.users.actions.resetPassword': 'Change Password',
  'pages.users.actions.deactivate': 'Deactivate',
  'pages.users.actions.revoke': 'Revoke Access',
  'pages.users.searchPlaceholder': 'Search users (name, username, email)',
  'pages.users.table.username': 'Username',
  'pages.users.table.fullName': 'Full Name',
  'pages.users.table.email': 'Email',
  'pages.users.table.globalRole': 'Global Role',
  'pages.users.table.origin': 'Imported From',
  'pages.users.table.status': 'Status',
  'pages.users.table.lastLogin': 'Last Login',
  'pages.users.table.actions': 'Actions',
  'pages.users.revokeConfirm.title': 'Revoke Platform Access',
  'pages.users.revokeConfirm.content': 'Are you sure you want to revoke the user\'s access to "{platformName}"? They will no longer be able to sign in to this platform.',
  'pages.users.revokeConfirm.ok': 'Revoke',
  'pages.users.revokeConfirm.success': 'Platform access revoked.',
  'pages.profile.profileUpdated': 'Profile updated successfully.',
  'pages.profile.passwordUpdated': 'Password updated. Please sign in with the new password.',
  'pages.profile.basicInfo.title': 'Basic Information',
  'pages.profile.basicInfo.description': 'Update your name and contact email. Email is used for notifications and can be left empty.',
  'pages.profile.security.title': 'Security Settings',
  'pages.profile.security.description': 'Update your password regularly and use at least 8 characters for better security.',
  'pages.profile.form.username.label': 'Username',
  'pages.profile.form.fullName.label': 'Full name',
  'pages.profile.form.fullName.required': 'Please enter your name',
  'pages.profile.form.fullName.min': 'Name must be at least 2 characters',
  'pages.profile.form.fullName.placeholder': 'Enter your name',
  'pages.profile.form.email.label': 'Email',
  'pages.profile.form.email.invalid': 'Please enter a valid email address',
  'pages.profile.form.email.placeholder': 'Optional email for notifications',
  'pages.profile.form.basic.submit': 'Save profile',
  'pages.profile.form.currentPassword.label': 'Current password',
  'pages.profile.form.currentPassword.required': 'Please enter your current password',
  'pages.profile.form.currentPassword.placeholder': 'Enter your current password',
  'pages.profile.form.newPassword.label': 'New password',
  'pages.profile.form.newPassword.required': 'Please enter a new password',
  'pages.profile.form.newPassword.min': 'Password must be at least 8 characters',
  'pages.profile.form.newPassword.placeholder': 'Enter a new password',
  'pages.profile.form.confirmPassword.label': 'Confirm new password',
  'pages.profile.form.confirmPassword.required': 'Please confirm the new password',
  'pages.profile.form.confirmPassword.mismatch': 'The two passwords do not match',
  'pages.profile.form.confirmPassword.placeholder': 'Re-enter the new password',
  'pages.profile.form.password.submit': 'Update password',
  'pages.dashboard.error.unknown': 'Unknown error',
  'pages.dashboard.loadError': 'Failed to load overview data: {detail}',
  'pages.dashboard.assignmentsError': 'Failed to load platform assignments. Please retry later.',
  'pages.dashboard.quickLogin.missingSlug': 'Platform identifier is missing; cannot start login.',
  'pages.dashboard.assignments.empty': 'You do not have access to any business platforms yet.',
  'pages.dashboard.assignments.contactAdmin': 'Contact the system administrator if you need access to a specific platform.',
  'pages.dashboard.myPlatforms.title': 'My Platforms',
  "pages.dashboard.myPlatforms.description": "Tap an icon to open that system.",
  'pages.dashboard.platform.unnamed': 'Untitled platform',
  'pages.dashboard.platform.noDescription': 'No platform description',
  'pages.dashboard.platform.slug': 'Platform slug: ',
  'pages.dashboard.platform.account': 'Your platform account: ',
  'pages.dashboard.platform.accountAuto': 'The platform account will be assigned automatically.',
  'pages.dashboard.actions.quickLogin': 'Quick Login',
  'pages.dashboard.actions.visitPortal': 'Open Portal',
  'pages.dashboard.overview.title': 'System Overview',
  'pages.dashboard.overview.userCount': 'System Users',
  'pages.dashboard.overview.activePlatforms': 'Active Platforms',
  'pages.dashboard.overview.roles': 'Defined Roles',
  'pages.dashboard.recentUsers.title': 'Recently Signed-in Users',
  'pages.dashboard.recentUsers.empty': 'No recent sign-ins',
  'pages.dashboard.recentUsers.lastLogin': 'Last login: {time}',
  'pages.dashboard.recentUsers.never': 'Never signed in',
  'pages.roles.scope.global': 'Global',
  'pages.roles.scope.platform': 'Platform',
  'pages.roles.loadError': 'Failed to load roles, please try again later.',
  'pages.roles.updateSuccess': 'Role updated successfully.',
  'pages.roles.createSuccess': 'Role created successfully.',
  'pages.roles.table.name': 'Role Name',
  'pages.roles.table.slug': 'Identifier',
  'pages.roles.table.scope': 'Type',
  'pages.roles.table.description': 'Description',
  'pages.roles.table.actions': 'Actions',
  'pages.roles.headerTitle': 'Role Management',
  'pages.roles.searchPlaceholder': 'Search by role name, slug, or description',
  'pages.roles.actions.create': 'Add Role',
  'pages.roles.modal.editTitle': 'Edit Role',
  'pages.roles.modal.createTitle': 'Add Role',
  'pages.roles.form.name.label': 'Role Name',
  'pages.roles.form.name.placeholder': 'Enter role name',
  'pages.roles.form.name.required': 'Please enter a role name',
  'pages.roles.form.slug.label': 'Role Identifier',
  'pages.roles.form.slug.placeholder': 'Enter a unique identifier',
  'pages.roles.form.slug.required': 'Please enter an identifier',
  'pages.roles.form.slug.pattern': 'Only lowercase letters, numbers, and dashes are allowed',
  'pages.roles.form.scope.label': 'Role Type',
  'pages.roles.form.scope.placeholder': 'Select a role type',
  'pages.roles.form.scope.required': 'Please select a role type',
  'pages.roles.form.scope.global': 'Global Role',
  'pages.roles.form.scope.platform': 'Platform Role',
  'pages.roles.form.description.label': 'Description',
  'pages.roles.form.description.placeholder': 'Describe what this role controls (optional)',
  'pages.groups.headerTitle': 'Group Management',
  'pages.groups.searchPlaceholder': 'Search by name or slug',
  'pages.groups.actions.create': 'New Group',
  'pages.groups.actions.members': 'Members',
  'pages.groups.actions.platforms': 'Platforms',
  'pages.groups.actions.archive': 'Archive',
  'pages.groups.table.name': 'Name',
  'pages.groups.table.slug': 'Slug',
  'pages.groups.table.description': 'Description',
  'pages.groups.table.members': 'Members',
  'pages.groups.table.platforms': 'Platforms',
  'pages.groups.table.status': 'Status',
  'pages.groups.table.actions': 'Actions',
  'pages.groups.optionsLoadError': 'Failed to load options',
  'pages.groups.loadError': 'Failed to load groups',
  'pages.groups.archive.confirm': 'Archive this group?',
  'pages.groups.archiveSuccess': 'Group archived',
  'pages.groups.archiveError': 'Unable to archive group',
  'pages.groups.modal.editTitle': 'Edit Group',
  'pages.groups.modal.createTitle': 'Create Group',
  'pages.groups.modal.updateSuccess': 'Group updated',
  'pages.groups.modal.createSuccess': 'Group created',
  'pages.groups.modal.submitError': 'Save failed',
  'pages.groups.form.name.label': 'Group Name',
  'pages.groups.form.name.placeholder': 'Enter a friendly name',
  'pages.groups.form.name.required': 'Please enter a group name',
  'pages.groups.form.slug.label': 'Group Slug',
  'pages.groups.form.slug.placeholder': 'Unique identifier (letters, digits, dash)',
  'pages.groups.form.slug.required': 'Please enter a slug',
  'pages.groups.form.description.label': 'Description',
  'pages.groups.form.description.placeholder': 'Describe the purpose (optional)',
  'pages.groups.members.title': 'Manage members for "{name}"',
  'pages.groups.members.titleFallback': 'Manage members',
  'pages.groups.members.loadError': 'Failed to load members',
  'pages.groups.members.selectUser': 'Select a user to add',
  'pages.groups.members.role.owner': 'Owner',
  'pages.groups.members.role.member': 'Member',
  'pages.groups.members.addAction': 'Add',
  'pages.groups.members.columns.name': 'Name',
  'pages.groups.members.columns.role': 'Role',
  'pages.groups.members.columns.actions': 'Actions',
  'pages.groups.members.removeConfirm': 'Remove this member?',
  'pages.groups.members.remove': 'Remove',
  'pages.groups.members.addSuccess': 'Member added',
  'pages.groups.members.addError': 'Failed to add member',
  'pages.groups.members.removeSuccess': 'Member removed',
  'pages.groups.members.removeError': 'Failed to remove member',
  'pages.groups.platforms.title': 'Manage platform access for "{name}"',
  'pages.groups.platforms.titleFallback': 'Manage platform access',
  'pages.groups.platforms.loadError': 'Failed to load platform access',
  'pages.groups.platforms.selectPlatform': 'Select a platform',
  'pages.groups.platforms.addAction': 'Add Platform',
  'pages.groups.platforms.columns.name': 'Platform',
  'pages.groups.platforms.columns.actions': 'Actions',
  'pages.groups.platforms.removeConfirm': 'Remove this platform?',
  'pages.groups.platforms.remove': 'Remove',
  'pages.groups.platforms.addSuccess': 'Platform assigned',
  'pages.groups.platforms.addError': 'Failed to assign platform',
  'pages.groups.platforms.removeSuccess': 'Platform revoked',
  'pages.groups.platforms.removeError': 'Failed to revoke platform',
  'pages.platforms.table.apiKey': 'API Key',
  'pages.platforms.labels.apiKey': 'API Key:',
  'pages.platforms.labels.apiSecret': 'API Secret:',
  'pages.users.deactivateConfirm.title': 'Deactivate User',
  'pages.users.deactivateConfirm.content': 'Deactivate user "{name}"?',
  'pages.users.deactivateConfirm.success': 'User deactivated.',
  'pages.users.drawer.titleWithName': '{name}\'s Platform Access',
  'pages.users.drawer.title': 'Platform Access',
  'pages.users.drawer.description': 'The user can sign in to the following business platforms via single sign-on.',
  'pages.users.drawer.assignButton': 'Grant Platforms',
  'pages.users.drawer.originLabel': 'Origin: ',
  'pages.users.drawer.originPlatform': '{name} ({slug})',
  'pages.users.drawer.originSystem': 'Created by system / self-registration',
  'pages.users.drawer.methodLabel': 'Provisioning Method: ',
  'pages.users.drawer.methodImported': 'Imported from platform; uses that platform\'s credentials',
  'pages.users.drawer.methodDefault': 'System account; uses global credentials',
  'pages.users.drawer.alertTitle': 'Permission Notice',
  'pages.users.drawer.alertDescription': 'Korsmet Auth only manages whether a user can sign in to a business platform. Feature and data permissions are still managed within each platform.',
  'pages.users.drawer.table.platform': 'Platform',
  'pages.users.drawer.table.platformUserId': 'Platform User ID',
  'pages.users.drawer.table.assignedAt': 'Assigned At',
  'pages.users.drawer.empty': 'No platform access assigned yet',
  'pages.users.messages.updateSuccess': 'User updated.',
  'pages.users.messages.createSuccess': 'User created successfully.',
  'pages.users.messages.passwordRequired': 'Please set an initial password.',
  'pages.users.messages.passwordResetSuccess': 'Password changed.',
  'pages.users.form.editTitle': 'Edit User',
  'pages.users.form.createTitle': 'Add User',
  'pages.users.form.username.label': 'Username',
  'pages.users.form.username.placeholder': 'Enter username',
  'pages.users.form.username.required': 'Please enter a username',
  'pages.users.form.username.min': 'Username must be at least 3 characters',
  'pages.users.form.password.label': 'Password',
  'pages.users.form.password.placeholder': 'Enter password',
  'pages.users.form.password.required': 'Please enter a password',
  'pages.users.form.password.min': 'Password must be at least 8 characters',
  'pages.users.form.fullName.label': 'Full Name',
  'pages.users.form.fullName.placeholder': 'Enter full name',
  'pages.users.form.fullName.required': 'Please enter a full name',
  'pages.users.form.email.label': 'Email',
  'pages.users.form.email.placeholder': 'Enter email (optional)',
  'pages.users.form.email.invalid': 'Please enter a valid email address',
  'pages.users.form.globalRole.label': 'Global Role',
  'pages.users.form.globalRole.placeholder': 'Select a global role (optional)',
  'pages.users.form.addFrom.label': 'Imported Platform',
  'pages.users.form.addFrom.placeholder': 'Select the source platform (optional)',
  'pages.users.form.status.label': 'Status',
  'pages.users.passwordModal.title': 'Change {name}\'s Password',
  'pages.users.passwordModal.titleWithoutName': 'Change User Password',
  'pages.users.passwordModal.selfNotAllowed': 'You cannot change your own password from user management.',
  'pages.users.passwordModal.alertTitle': 'The user will need to sign in again after this change.',
  'pages.users.passwordModal.newPassword.label': 'New Password',
  'pages.users.passwordModal.newPassword.placeholder': 'Enter a new password',
  'pages.users.passwordModal.newPassword.required': 'Please enter a new password',
  'pages.users.passwordModal.confirmPassword.label': 'Confirm New Password',
  'pages.users.passwordModal.confirmPassword.placeholder': 'Re-enter the new password',
  'pages.users.passwordModal.confirmPassword.required': 'Please confirm the new password',
  'pages.users.passwordModal.confirmPassword.mismatch': 'The two passwords do not match',
  'pages.users.assignModal.title': 'Grant platform access to {name}',
  'pages.users.assignModal.titleWithoutName': 'Grant platform access',
  'pages.users.assignModal.alertTitle': 'Batch Granting',
  'pages.users.assignModal.alertDescription': 'Choose the business platforms to grant. The user will be able to sign in via SSO. Click the tags to toggle.',
  'pages.users.assignModal.selectAll': 'Select All',
  'pages.users.assignModal.clear': 'Clear',
  'pages.users.assignModal.invert': 'Invert Selection',
  'pages.users.assignModal.result.assigned': 'Granted {count} platform(s)',
  'pages.users.assignModal.result.revoked': 'Revoked {count} platform(s)',
  'pages.users.assignModal.result.failed': '{count} operation(s) failed',
  'pages.users.assignModal.emptyPlatforms': 'No platforms available to grant',
  'pages.platforms.title': 'Platform Management',
  'pages.platforms.searchPlaceholder': 'Search platform name, slug, or API key',
  'pages.platforms.actions.create': 'Add Platform',
  'pages.platforms.actions.edit': 'Edit',
  'pages.platforms.actions.regenerate': 'Regenerate Keys',
  'pages.platforms.actions.archive': 'Archive',
  'pages.platforms.updateSuccess': 'Platform updated.',
  'pages.platforms.createSuccess.title': 'Platform created',
  'pages.platforms.createSuccess.description': 'An API key pair has been generated. Please store it securely:',
  'pages.platforms.createSuccess.warning': 'You cannot view the full secrets again after closing. Regenerate if lost.',
  'pages.platforms.archiveConfirm.title': 'Archive Platform',
  'pages.platforms.archiveConfirm.content': 'Archive platform "{name}"? It will no longer appear in selections.',
  'pages.platforms.archiveConfirm.success': 'Platform archived.',
  'pages.platforms.regenerateConfirm.title': 'Regenerate API Keys',
  'pages.platforms.regenerateConfirm.content': 'Regenerate API keys for platform "{name}"?',
  'pages.platforms.regenerateConfirm.warning': 'Existing keys will be invalid immediately. Update downstream systems in time.',
  'pages.platforms.regenerateConfirm.ok': 'Regenerate',
  'pages.platforms.regenerateSuccess.title': 'API keys regenerated',
  'pages.platforms.regenerateSuccess.description': 'Store these keys securely. You cannot see the full values again:',
  'pages.platforms.table.name': 'Name',
  'pages.platforms.table.slug': 'Slug',
  'pages.platforms.table.description': 'Description',
  'pages.platforms.table.status': 'Status',
  'pages.platforms.table.actions': 'Actions',
  'pages.platforms.form.editTitle': 'Edit Platform',
  'pages.platforms.form.createTitle': 'Add Platform',
  'pages.platforms.form.name.label': 'Platform Name',
  'pages.platforms.form.name.placeholder': 'Enter platform name',
  'pages.platforms.form.name.required': 'Please enter a platform name',
  'pages.platforms.form.slug.label': 'Platform Slug',
  'pages.platforms.form.slug.placeholder': 'Enter platform slug',
  'pages.platforms.form.slug.required': 'Please enter a platform slug',
  'pages.platforms.form.slug.pattern': 'Lowercase letters, numbers, and hyphen only',
  'pages.platforms.form.description.label': 'Description',
  'pages.platforms.form.description.placeholder': 'Enter description (optional)',
  'pages.platforms.form.jwtAccessSecret.placeholder': 'Platform-specific JWT access token secret (optional)',
  'pages.platforms.form.jwtRefreshSecret.placeholder': 'Platform-specific JWT refresh token secret (optional)',
  'pages.platforms.form.status.label': 'Status',
};
